import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  complianceStageSettings: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.complianceStageSettings`,
    defaultMessage: 'Compliance Stage Settings',
  },
  autoAdvanceLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.autoAdvanceLabel`,
    defaultMessage: 'Auto-advance applicant to next stage',
  },
  noAutoAdvance: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.noAutoAdvance`,
    defaultMessage: 'Do not auto-advance',
  },
  moveApplicant: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.moveApplicant`,
    defaultMessage: 'When applicant is in compliance (recommended)',
  },
  moveApplicantOnSubmission: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.moveApplicantOnSubmission`,
    defaultMessage: 'When all documents are submitted',
  },
  requirementsLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.requirementsLabel`,
    defaultMessage: 'Requirements to evaluate (optional)',
  },
  requirementsHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.requirementsHelperText`,
    defaultMessage:
      'Select specific requirements for this stage. If none are selected, all requirements apply.',
  },
  requirementsPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.ComplianceStage.requirementsPlaceholder`,
    defaultMessage: 'All requirements',
  },
});
